import React from 'react';
import { motion } from 'framer-motion';
import { UserCheck, CalendarPlus, Banknote } from 'lucide-react';
import { howItWorksSteps } from '../data/mock';

const iconMap = {
  UserCheck: UserCheck,
  CalendarPlus: CalendarPlus,
  Banknote: Banknote,
};

const HowItWorksSection = () => {
  return (
    <section id="how-it-works" className="section-padding bg-white">
      <div className="container mx-auto">
        {/* Section Header */}
        <div className="text-center mb-16">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5 }}
          >
            <span
              className="inline-block px-4 py-1.5 rounded-full text-sm font-medium mb-4"
              style={{ background: 'var(--accent-wash)', color: 'var(--accent-text)' }}
            >
              Simple Process
            </span>
            <h2 className="heading-2 mb-4">How Crew Up Works</h2>
            <p className="body-large max-w-2xl mx-auto">
              Get connected with quality hospitality staff or find flexible work in three simple steps.
            </p>
          </motion.div>
        </div>

        {/* Steps */}
        <div className="grid md:grid-cols-3 gap-8 lg:gap-12">
          {howItWorksSteps.map((step, index) => {
            const Icon = iconMap[step.icon];
            return (
              <motion.div
                key={step.step}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: index * 0.15 }}
                className="relative"
              >
                {/* Connection Line (desktop only) */}
                {index < howItWorksSteps.length - 1 && (
                  <div className="hidden md:block absolute top-16 left-1/2 w-full h-px" style={{ background: 'var(--border-light)' }} />
                )}

                <div className="feature-card text-center relative">
                  {/* Step Number */}
                  <div
                    className="absolute -top-4 left-1/2 -translate-x-1/2 w-8 h-8 rounded-full flex items-center justify-center text-sm font-bold"
                    style={{ background: 'var(--accent-primary)', color: 'var(--text-primary)' }}
                  >
                    {step.step}
                  </div>

                  {/* Icon */}
                  <div
                    className="w-16 h-16 rounded-2xl mx-auto mb-6 flex items-center justify-center"
                    style={{ background: 'var(--accent-wash)' }}
                  >
                    <Icon size={32} style={{ color: 'var(--accent-text)' }} />
                  </div>

                  {/* Content */}
                  <h3 className="heading-3 mb-3">{step.title}</h3>
                  <p className="body-medium" style={{ color: 'var(--text-secondary)' }}>
                    {step.description}
                  </p>
                </div>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default HowItWorksSection;
